import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { QUERY_KEY } from '~common';
import { getRequest } from '~services';
import { Pricing } from '~types/pricing.type';

export const useQueryGetStationPricing = (
  reqParams: {
    serialNumberOrImei: string;
    paymentMethodId?: string;
  },
  options?: Omit<
    UseQueryOptions<
      Pricing,
      AxiosError<Record<string, string>>,
      Pricing,
      (QUERY_KEY | string)[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const getPricing = (): Promise<Pricing> =>
    getRequest({
      path: 'api/station/pricing',
      params: {
        ...reqParams,
        platform: 'WEB',
      },
    });

  return useQuery(
    [
      QUERY_KEY.GET_STATION_PRICING,
      reqParams.serialNumberOrImei,
      reqParams.paymentMethodId ?? '',
    ],
    () => getPricing(),
    {
      ...options,
    },
  );
};
